module.exports = __webpack_public_path__ + "img/water9.2d412e48.jpg";